import { types } from '@actions/sidebar';

export const initialState = {
  active: false, // active is false or timestamp if true. Needed for delayed close.
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.OPEN:
      return {
        ...state,
        active: +new Date(),
      };
    case types.PUSH:
      return state;
    case types.CLOSE: {
      if (action.active === state.active) return initialState;
      return state;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/sidebar.js